// extracted by mini-css-extract-plugin
export default {"left":"left_left__679ww"};